import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0080c5',
                secondary: '#f9cd46',
                local: '#105A8C',
                govt: '#f9cd46',
                accent: '#fadb7c',
                error: '#cd0c13',
                black: '#121212',
                scdhb: '#007165',
                white: '#fff',
                black: '#000',
                dark: '#00496a'
            },
        },
        options: {
            customProperties: true,
        },
    },
});
